import React, { Component } from 'react';
import { connect } from 'react-redux';
import NoticeProductItemListModal from '../../../../views/app/common/modal/NoticeProductItemListModal';
import withModal from '../../../../lib/hoc/withModal';
import { appActions } from '../../../../store/modules/app';

class NoticeProductItemListModalContainer extends Component {
  componentDidMount = () => {
    const { data } = this.props;
    const { pagination } = data.listData;
    this.getNoticeProductItemList({
      pagination,
      productNoticeId: data.productNoticeId,
    });
  };

  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    this.props.toggleModal({
      name: 'noticeProductItemListModal',
      data: {
        listData: {
          list: [],
          pagination: {
            pageSize: 100,
            pageNum: 0,
            pages: -1,
          },
        },
        productNoticeId: null,
      },
      value: false,
    });
  };

  /**
   * 상품 공지사항 아이템 리스트 가져오기
   */
  getNoticeProductItemList = (option) => {
    const { pagination } = option;
    const { getNoticeProductItemList, data } = this.props;
    const { productNoticeId } = data;

    getNoticeProductItemList({
      pagination,
      productNoticeId,
    });
  };

  render() {
    return (
      <NoticeProductItemListModal
        {...this.state}
        {...this.props}
        closeModal={this.closeModal}
        getNoticeProductItemList={this.getNoticeProductItemList}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.noticeProductItemListModal.isOpen,
    data: state.app.noticeProductItemListModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: appActions.appToggleModal,
  getNoticeProductItemList: appActions.getNoticeProductItemList,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(NoticeProductItemListModalContainer));
